module.exports = __webpack_public_path__ + "media/icons/support-d85fe0f3.svg";